import { render } from "./DriverBlackList.vue?vue&type=template&id=c0c77ed6&scoped=true"
import script from "./DriverBlackList.vue?vue&type=script&lang=js"
export * from "./DriverBlackList.vue?vue&type=script&lang=js"

import "./DriverBlackList.vue?vue&type=style&index=0&id=c0c77ed6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c77ed6"]])

export default __exports__